// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qfoVV","rightAdornment":"Header_rightAdornment__1uKhX"};